module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settingpage"
  }, [_c('div', {
    staticClass: "right_col",
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "main_main_contents"
  }, [_vm._m(0), _c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "h3"
  }, [_vm._v("名前の変更")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("氏名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.name.$dirty && _vm.$v.name.$invalid
    },
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "blur": _vm.update,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, _vm.$v.name.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.name.$dirty && _vm.$v.name.$invalid),
      expression: "$v.name.$dirty && $v.name.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.name.required),
      expression: "!$v.name.required"
    }]
  }, [_vm._v("必須項目です")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "kana"
    }
  }, [_vm._v("フリガナ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kana),
      expression: "kana"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.kana.$dirty && _vm.$v.kana.$invalid
    },
    attrs: {
      "id": "kana",
      "name": "kana",
      "type": "text"
    },
    domProps: {
      "value": (_vm.kana)
    },
    on: {
      "blur": _vm.update,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.kana = $event.target.value
      }, _vm.$v.kana.$touch]
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.kana.$dirty && _vm.$v.kana.$invalid),
      expression: "$v.kana.$dirty && $v.kana.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.kana.required),
      expression: "!$v.kana.required"
    }]
  }, [_vm._v("必須項目です")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.kana.kana),
      expression: "!$v.kana.kana"
    }]
  }, [_vm._v("全角カナで入力してください")])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "h3"
  }, [_vm._v("署名設定")]), _c('h4', [_vm._v("署名1")]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "title1"
    }
  }, [_vm._v("タイトル")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signature_title1),
      expression: "signature_title1"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.signature_title1.$invalid
    },
    attrs: {
      "id": "title1",
      "name": "signature_title1",
      "type": "text",
      "placeholder": "（例）職場用"
    },
    domProps: {
      "value": (_vm.signature_title1)
    },
    on: {
      "blur": _vm.update,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signature_title1 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.signature_title1.$invalid),
      expression: "$v.signature_title1.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.signature_title1.maxLength),
      expression: "!$v.signature_title1.maxLength"
    }]
  }, [_vm._v("50文字以下で入力してください")])])])]), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "signature1"
    }
  }, [_vm._v("署名")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signature1),
      expression: "signature1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signature1",
      "name": "signature1",
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.signature1)
    },
    on: {
      "blur": _vm.update,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signature1 = $event.target.value
      }
    }
  })])]), _c('h4', [_vm._v("署名2")]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "title2"
    }
  }, [_vm._v("タイトル")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signature_title2),
      expression: "signature_title2"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.signature_title2.$invalid
    },
    attrs: {
      "id": "title2",
      "name": "signature_title2",
      "type": "text",
      "placeholder": "（例）プライベート用"
    },
    domProps: {
      "value": (_vm.signature_title2)
    },
    on: {
      "blur": _vm.update,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signature_title2 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.signature_title2.$invalid),
      expression: "$v.signature_title2.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.signature_title2.maxLength),
      expression: "!$v.signature_title2.maxLength"
    }]
  }, [_vm._v("50文字以下で入力してください")])])])]), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "signature2"
    }
  }, [_vm._v("署名")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signature2),
      expression: "signature2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signature2",
      "name": "signature2",
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.signature2)
    },
    on: {
      "blur": _vm.update,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signature2 = $event.target.value
      }
    }
  })])]), _c('h4', [_vm._v("署名3")]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "title3"
    }
  }, [_vm._v("タイトル")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signature_title3),
      expression: "signature_title3"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.signature_title3.$invalid
    },
    attrs: {
      "id": "title3",
      "name": "signature_title3",
      "type": "text"
    },
    domProps: {
      "value": (_vm.signature_title3)
    },
    on: {
      "blur": _vm.update,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signature_title3 = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.signature_title3.$invalid),
      expression: "$v.signature_title3.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.signature_title3.maxLength),
      expression: "!$v.signature_title3.maxLength"
    }]
  }, [_vm._v("50文字以下で入力してください")])])])]), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h5 control-label",
    attrs: {
      "for": "signature3"
    }
  }, [_vm._v("署名")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signature3),
      expression: "signature3"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signature3",
      "name": "signature3",
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.signature3)
    },
    on: {
      "blur": _vm.update,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signature3 = $event.target.value
      }
    }
  })])]), _c('h4', [_vm._v("デフォルト署名設定")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.default_signature),
      expression: "default_signature"
    }],
    staticClass: "signselect selectitems",
    on: {
      "blur": _vm.update,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.default_signature = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("---")]), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.signature_title1 && _vm.signature1),
      expression: "signature_title1 && signature1"
    }],
    domProps: {
      "value": 1
    }
  }, [_vm._v(_vm._s(_vm.signature_title1))]), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.signature_title2 && _vm.signature2),
      expression: "signature_title2 && signature2"
    }],
    domProps: {
      "value": 2
    }
  }, [_vm._v(_vm._s(_vm.signature_title2))]), _c('option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.signature_title3 && _vm.signature3),
      expression: "signature_title3 && signature3"
    }],
    domProps: {
      "value": 3
    }
  }, [_vm._v(_vm._s(_vm.signature_title3))])])])]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "h3"
  }, [_vm._v("パスワード変更")]), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "password"
    }
  }, [_c('label', {
    staticClass: "h4 control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("現在のパスワード")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "text",
      "placeholder": "半角英数記号8文字以上で入力してください"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": _vm.passcheck,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h4 control-label",
    attrs: {
      "for": "newpassword"
    }
  }, [_vm._v("新しいパスワード")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newpassword),
      expression: "newpassword"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.newpassword.$invalid
    },
    attrs: {
      "id": "newpassword",
      "type": "text",
      "placeholder": "半角英数記号8文字以上で入力してください"
    },
    domProps: {
      "value": (_vm.newpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newpassword = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.newpassword.$invalid),
      expression: "$v.newpassword.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.newpassword.minLength),
      expression: "!$v.newpassword.minLength"
    }]
  }, [_vm._v("8文字以上20文字以下で入力してください")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.newpassword.maxLength),
      expression: "!$v.newpassword.maxLength"
    }]
  }, [_vm._v("8文字以上20文字以下で入力してください")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.newpassword.ascii),
      expression: "!$v.newpassword.ascii"
    }]
  }, [_vm._v("半角英数記号で入力してください")])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h4 control-label",
    attrs: {
      "for": "repeatpassword"
    }
  }, [_vm._v("新しいパスワード（確認用）")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatpassword),
      expression: "repeatpassword"
    }],
    staticClass: "form-control",
    class: {
      invalid: _vm.$v.repeatpassword.$invalid
    },
    attrs: {
      "id": "repeatpassword",
      "type": "text",
      "placeholder": "半角英数記号8文字以上で入力してください"
    },
    domProps: {
      "value": (_vm.repeatpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatpassword = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.repeatpassword),
      expression: "repeatpassword"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.repeatpassword.$invalid),
      expression: "$v.repeatpassword.$invalid"
    }],
    staticClass: "error"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.repeatpassword.sameAs),
      expression: "!$v.repeatpassword.sameAs"
    }]
  }, [_vm._v("パスワードが一致しません")])])])])]), _c('div', {
    staticClass: "col-xs-1"
  }, [_c('button', {
    staticClass: "customsmallbutton btn btn-success pass_savebutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.passupdate
    }
  }, [_vm._v("変 更")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "title_left"
  }, [_c('h2', [_vm._v("個人設定")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60cd331a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/UserSettings.vue
// module id = 604
// module chunks = 1